var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"custom-icon",style:(_vm.cStyle),on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }